__turbopack_context__.v({
  "black": "Credits-module-scss-module__XPjmEq__black",
  "blink": "Credits-module-scss-module__XPjmEq__blink",
  "clickOpen": "Credits-module-scss-module__XPjmEq__clickOpen",
  "col": "Credits-module-scss-module__XPjmEq__col",
  "collapsibleContent": "Credits-module-scss-module__XPjmEq__collapsibleContent",
  "credits": "Credits-module-scss-module__XPjmEq__credits",
  "creditsAll": "Credits-module-scss-module__XPjmEq__creditsAll",
  "creditsInner": "Credits-module-scss-module__XPjmEq__creditsInner",
  "opened": "Credits-module-scss-module__XPjmEq__opened",
  "row": "Credits-module-scss-module__XPjmEq__row",
  "topRow": "Credits-module-scss-module__XPjmEq__topRow",
  "white": "Credits-module-scss-module__XPjmEq__white",
});
